/**
 * Small pure view-derivation helpers shared by multiple components.
 * Kept separate from the components themselves so they're easy to reason
 * about (and could be unit tested later) independent of React.
 */
import type { ActionLogEntry, HandState, PlayerIndex, Position } from "@joker-holdem/core";

export function chipsToBb(chips: number): number {
  return chips / 2;
}

export function formatBb(chips: number): string {
  return `${chipsToBb(chips).toFixed(1)}bb`;
}

export function positionLabel(hand: Pick<HandState, "button">, seat: PlayerIndex): Position {
  return seat === hand.button ? "BTN/SB" : "BB";
}

/** The most recent action this seat took on the current street, if any. */
export function lastActionForSeat(
  hand: HandState,
  seat: PlayerIndex
): ActionLogEntry | undefined {
  for (let i = hand.actionLog.length - 1; i >= 0; i--) {
    const entry = hand.actionLog[i]!;
    if (entry.street !== hand.street) break;
    if (entry.player === seat) return entry;
  }
  return undefined;
}

/**
 * True when the hand ended by a preflop fold -- that case skips the result
 * UI entirely and auto-advances instantly instead (docs/UI_REFERENCE.md
 * "フィードバック反映" 2026-07-17 #2 例外).
 */
export function isPreflopFoldResult(hand: Pick<HandState, "result" | "street">): boolean {
  return hand.result?.endedBy === "fold" && hand.street === "preflop";
}
